import { render, staticRenderFns } from "./UserShell.vue?vue&type=template&id=82f3cd94&scoped=true"
import script from "./UserShell.vue?vue&type=script&lang=js"
export * from "./UserShell.vue?vue&type=script&lang=js"
import style0 from "./UserShell.vue?vue&type=style&index=0&id=82f3cd94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82f3cd94",
  null
  
)

export default component.exports